// @flow
import React from 'react';
import { STREAM_GOVERNANCE_WORKLOADS_INPUTS_FIELDNAMES } from '@streaming-projects/orgs/enums';
import { TextField } from '@src/formik-utils/FormFields';
import { STREAM_GOVERNANCE_WORKLOAD_DETAILS_CONFIG_MAP } from '@streaming-projects/workloads/stream-governance-workloads/config';

export const SPStreamGovernanceWorkloadNameContainer = ({
  disabled = false,
  fluid = null,
  disableOnFormErrors = null,
}) => {
  const { backendFieldName, displayName } = STREAM_GOVERNANCE_WORKLOAD_DETAILS_CONFIG_MAP.get(
    STREAM_GOVERNANCE_WORKLOADS_INPUTS_FIELDNAMES.WORKLOAD_NAME
  );
  return (
    <TextField
      disableOnFormErrors={disableOnFormErrors}
      disabled={disabled}
      fieldDisplayName={displayName}
      fieldName={backendFieldName}
      fluid={fluid}
    />
  );
};
